﻿import Vue from "vue";
import Component from "vue-class-component";
import HotEditableFormManager_ from "./hotEditable/HotEditableFormManager";
import common from "../../common";
import SharedFormManager_ from "./hotEditable/SharedFormManager";
import HotEditableFormLoader_ from "./hotEditable/HotEditableFormLoader";
import context_ from "../context";
import utilities_ from "../utilities";
import HotEditableSelectComponent_ from "./hotEditable/HotEditableSelectComponent";


declare function require(module: string): unknown;
const context = require("../context") as typeof context_;
const utilities = require("../utilities") as typeof utilities_;
// const SharedFormManager = require("./hotEditable/SharedFormManager") as SharedFormManager_;
// const HotEditableFormLoader = require("./hotEditable/HotEditableFormLoader") as HotEditableFormLoader_;
// const HotEditableSelectComponent = require("./hotEditable/HotEditableSelectComponent") as HotEditableSelectComponent_;
// const HotEditableFormManager = require("./hotEditable/HotEditableFormManager") as HotEditableFormManager_;

@Component
class NotesVue extends Vue implements common.IHotEditableFormVue {
    $initialData: any;

    shared?: SharedFormManager_;
    formMode = common.HotEditableFormModes.original;
    formManager?: HotEditableFormManager_ | null;
    isVisibleToggleButton = false;
    currentItemId?: string;
    currentItemTitle?: string;
    currentCommentItemId?: string;
    currentCommentId?: string;
    currentCommentText?: string;
    currentItem?: common.INote | null;
    currentlyEditingItem?: boolean;
    currentlyAddingComment?: boolean;
    currentlyEditingComment?: boolean;
    /** !!ATTENTION!! Utilise SEULEMENT dans l'Addition avec les 4 categories */
    items?: common.INote[];
    usageContext?: string;
    forceUpdate = "1";
    bag = {} as any;
    _bagTmp?: any;
    _manageButtonsOnFormModeChange?: boolean;
    _initialConcurrencySumCheck?: string | null;
    _defaultCreationTitle?: string;
    _onCheckItemClickCallbak?: ((item?: common.INote) => void) | null;
    _onEditItemClickCallbak?: ((item?: common.INote) => void) | null;
    _onDeleteItemClickCallbak?: ((item?: common.INote) => void) | null;
    _onEditCommentClickCallbak?: ((comment?: common.INoteCommentaire) => void) | null;
    _onEditCommentCancelClickCallbak?: ((item?: common.INote, comment?: common.INoteCommentaire) => void) | null;
    _onEditCommentSaveClickCallbak?: ((item?: common.INote, comment?: common.INoteCommentaire) => void) | null;
    _onDeleteCommentClickCallbak?: ((comment?: common.INoteCommentaire) => void) | null;
    _onAddCommentClickCallbak?: ((item?: common.INote) => void) | null;
    _onAddCommentCancelClickCallbak?: ((item?: common.INote) => void) | null;
    _onAddCommentSaveClickCallbak?: ((item?: common.INote) => void) | null;

    beforeCreate() {
        const rootId = (this as any).$initialData.vueElId as string;
        const initialConcurrencySumCheck = (this as any).$initialData.concurrencySumCheck as string || null;
        const includesConcurrencySumCheck = (this as any).$initialData.includesConcurrencySumCheck as boolean || !!initialConcurrencySumCheck;
        HotEditableFormLoader_.prepareComponentsMarkupFromTarget(true, includesConcurrencySumCheck, rootId).loadComponentsFromParent(this);

        this._initialConcurrencySumCheck = initialConcurrencySumCheck;
        this.usageContext = (this as any).$initialData.usageContext || null;

        this.currentItemId = "";
        this.currentItemTitle = "";
        this.currentCommentItemId = "";
        this.currentCommentId = "";
        this.currentCommentText = "";
        this.currentlyEditingItem = false;
        this.currentlyEditingComment = false;
        this.currentlyAddingComment = false;

        this.items = (this as any).$initialData.items || [];
        this._bagTmp = (this as any).$initialData.bag || {};
        this.$options.el = '#' + rootId;

        this.formManager = new HotEditableFormManager_(this, (this as any).$initialData.formName as string | null, {
            loadFormModeFromUrl: (this as any).$initialData.loadFormModeFromUrl !== false
        });
        this.shared = new SharedFormManager_(this.formManager);
    }

    destroyComponents() {
        this.formManager?.destroyComponents();
        this.formManager = null;//DESTROY (TEST)
        return this;
    }

    created() { }

    mounted() {
        this.bag = this._bagTmp;

        if (this._initialConcurrencySumCheck)
            this.$nextTick(() => {
                this.initConcurrencySumCheck(this._initialConcurrencySumCheck);
            });
    }
    setOnCheckItemClickCallbak(callback: (item?: common.INote) => void) {
        this._onCheckItemClickCallbak = callback || null;
        return this;
    }
    setOnEditItemClickCallbak(callback: (item?: common.INote) => void) {
        this._onEditItemClickCallbak = callback || null;
        return this;
    }
    setOnDeleteItemClickCallbak(callback: (item?: common.INote) => void) {
        this._onDeleteItemClickCallbak = callback || null;
        return this;
    }
    setOnEditCommentClickCallbak(callback: (comment?: common.INoteCommentaire) => void) {
        this._onEditCommentClickCallbak = callback || null;
        return this;
    }
    setOnEditCommentCancelClickCallbak(callback: (item?: common.INote, comment?: common.INoteCommentaire) => void) {
        this._onEditCommentCancelClickCallbak = callback || null;
        return this;
    }
    setOnEditCommentSaveClickCallbak(callback: (item?: common.INote, comment?: common.INoteCommentaire) => void) {
        this._onEditCommentSaveClickCallbak = callback || null;
        return this;
    }
    setOnDeleteCommentClickCallbak(callback: (comment?: common.INoteCommentaire) => void) {
        this._onDeleteCommentClickCallbak = callback || null;
        return this;
    }
    setOnAddCommentClickCallbak(callback: (item?: common.INote) => void) {
        this._onAddCommentClickCallbak = callback || null;
        return this;
    }
    setOnAddCommentCancelClickCallbak(callback: (item?: common.INote) => void) {
        this._onAddCommentCancelClickCallbak = callback || null;
        return this;
    }
    setOnAddCommentSaveClickCallbak(callback: (item?: common.INote) => void) {
        this._onAddCommentSaveClickCallbak = callback || null;
        return this;
    }
    setItems(items: common.INote[]) {
        this.items = items || [];
        return this;
    }
    setItem(item: common.INote) {
        if (this.items) for (let i = 0; i < this.items.length; i++) {
            const x = this.items[i];
            if (x.id === item.id)
                this.updateItem(item, x);
        }

        return this;
    }
    setComments(itemId: string, values: common.INoteCommentaire[]) {
        const item = this.getItemById(itemId);
        if (!item)
            return this;
        item.comments = values || [];
        return this;
    }
    getBagRaw() {
        const r = utilities.serializeBag(this.bag || {});
        return r;
    }
    private updateItem(source: common.INote, destination: common.INote) {
        if (!source)
            throw "L'argument 'source' est NULL.";
        if (!destination)
            throw "L'argument 'destination' est NULL.";
        destination.id = source.id;
        destination.date = source.date;
        destination.title = source.title;
        destination.description = source.description;
        destination.icon = source.icon;
        destination.author = source.author;
        destination.comments = source.comments;
        destination.commentNewText = source.commentNewText;
        destination.currentlyAddingComment = source.currentlyAddingComment;
        destination.currentlyEditingItem = source.currentlyEditingItem;
    }
    getFromBag(key: string) {
        const r = this.bag[key];
        return r || r === false || r === 0 || r === "" ? r : null;
    }
    setToBag(key: string, value: any) {
        this.$set(this.bag, key, value);
        return this;
    }
    getBooleanFromBag(key: string, defaultValue?: boolean) {
        const val = this.getFromBag(key);
        if (val === true || val === false)
            return val;
        return defaultValue ?? false;
    }
    setBooleanToBag(key: string, value: boolean) {
        this.setToBag(key, value === true);
        return this;
    }
    updateBagWhere(whereClause: (key: string, val?: any) => boolean, value?: any) {
        if (whereClause)
            for (let k in this.bag)
                if (whereClause(k, this.bag[k]))
                    this.bag[k] = value;
    }
    updateBagWhereKeyStartWith(startWith: string, value?: any, excludedKeys?: string | string[]) {
        if (!startWith) return;
        excludedKeys = excludedKeys || [];
        if (!Array.isArray(excludedKeys))
            excludedKeys = [excludedKeys];
        const isExcluded = (x: string) => {
            if (x)
                for (let i = 0; i < excludedKeys.length; i++)
                    if (excludedKeys[i] === x)
                        return true;
            return false;
        };
        this.updateBagWhere(k => !isExcluded(k) && k.startsWith(startWith), value);
    }
    updateBag(updated?: common.IBag) {
        var isUpdated = false;
        if (updated && updated.raw)
            for (let k in updated.raw) {
                this.bag[k] = updated.raw[k];
                if (!isUpdated)
                    isUpdated = true;
            }

        if (isUpdated)
            this.$forceUpdate();
        return this;
    }
    private initConcurrencySumCheck(sumCheck?: string | null) {
        const f = this.formManager?.getFieldByName("ConcurrencySumCheck");
        if (f)
            f.setFromTextualValue(sumCheck || "");
        return this;
    }
    setManageButtonsOnFormModeChange(value: boolean) {
        this._manageButtonsOnFormModeChange = value !== false;
        return this;
    }
    manageButtonsOnFormModeChange() {
        return this._manageButtonsOnFormModeChange !== false;
    }
    setActionConfirmation(key: string, action?: () => void) {
        if (!key)
            throw "L'argument 'key' est NULL.";

        const f = this.formManager?.getFieldByName(key);

        if (!f)
            throw "Le champ correspondant au nom '" + key + "' n'existe pas.";

        f.setFromTextualValue("true");

        if (action)
            this.$nextTick(action);

        return this;
    }
    getIcon(item: common.INote) {
        return "i-note";
    }
    getItemIconTitle(item: common.INote) {
        return "";
    }
    getItemTitle(item: common.INote) {
        if (item.currentlyEditingItem)
            return "Cette note est en cours de modification.";
        return "";
    }
    getItemDescription(item: common.INote) {
        return utilities.replaceLineBreakByBrTag(item.description);
    }
    getAddCommentActionTitle(item: common.INote) {
        if (this.currentlyEditingItem)
            return "Une note est déjà en cours de modification";
        if (this.currentlyEditingComment)
            return "Un commentaire est déjà en cours de modification";
        if (this.currentlyAddingComment)
            return "Un commentaire est déjà en cours de création";
        return "Ajouter un commentaire";
    }
    onCheckItemClick($event: Event, item: common.INote) {
        if (this._onCheckItemClickCallbak)
            this._onCheckItemClickCallbak(item);
    }
    onEditItemClick($event: Event, item: common.INote) {
        if (this.isSameItem(item, this.currentItem))
            return;
        if (this._onEditItemClickCallbak)
            this._onEditItemClickCallbak(item);
    }
    onDeleteItemClick($event: Event, item: common.INote) {
        if (this._onDeleteItemClickCallbak)
            this._onDeleteItemClickCallbak(item);
    }
    onEditCommentClick($event: Event, comment: common.INoteCommentaire) {
        if (this.currentlyEditingItem || this.currentlyAddingComment || this.currentlyEditingComment)
            return;

        if (this._onEditCommentClickCallbak)
            this._onEditCommentClickCallbak(comment);
    }
    onDeleteCommentClick($event: Event, comment: common.INoteCommentaire) {
        if (this._onDeleteCommentClickCallbak)
            this._onDeleteCommentClickCallbak(comment);
    }
    onEditCommentCancelClick($event: Event, item: common.INote, comment: common.INoteCommentaire) {
        if (this._onEditCommentCancelClickCallbak)
            this._onEditCommentCancelClickCallbak(item, comment);
    }
    onEditCommentSaveClick($event: Event, item: common.INote, comment: common.INoteCommentaire) {
        if (this._onEditCommentSaveClickCallbak)
            this._onEditCommentSaveClickCallbak(item, comment);
    }
    onAddCommentClick($event: Event, item: common.INote) {
        if (this.currentlyEditingItem || this.currentlyAddingComment || this.currentlyEditingComment)
            return;

        if (this._onAddCommentClickCallbak)
            this._onAddCommentClickCallbak(item);
    }
    onAddCommentSaveClick($event: Event, item: common.INote) {
        if (this._onAddCommentSaveClickCallbak)
            this._onAddCommentSaveClickCallbak(item);
    }
    onAddCommentCancelClick($event: Event, item: common.INote) {
        if (this._onAddCommentCancelClickCallbak)
            this._onAddCommentCancelClickCallbak(item);
    }
    onCancelButtonClick() {
        this.resetCurrentItem();
    }
    isSameItem(a?: common.INote | null, b?: common.INote | null) {
        return a && b && a.id === b.id;
    }
    hasDescription() {
        const field = this.formManager?.getFieldByName("Description");
        const value = ((field?.elementValue as string) || "").trim();
        return !!value;
    }
    isEditingItem() {
        if (!this.currentItem)
            return false;

        const description = this.formManager?.getFieldByName("Description");
        if ((description?.elementValue || "").trim() !== (this.currentItem.description || "").trim())
            return true;

        return false;
    }
    isAddingItem() {
        if (this.currentItemId)
            return false;

        const description = this.formManager?.getFieldByName("Description");
        if ((description?.elementValue || "").trim())
            return true;

        return false;
    }
    /** Si 'item' est NULL, alors retournera TRUE si une note quelconque est en addition de commentaire, sinon retournera TRUE si la note est en addition de commentaire. */
    isAddingComment(item?: common.INote | null) {
        item = item || this.getCurrentlyAddingCommentItem();
        return item && !!(item.commentNewText || "").trim();
    }
    /** Si 'item' est NULL, alors retournera TRUE si une note quelconque est en addition de commentaire, sinon retournera TRUE si la note est en addition de commentaire. */
    isEditingComment(comment?: common.INoteCommentaire | null) {
        comment = comment || this.getCurrentlyEditingCommentItem();
        if (!comment)
            return false;
        const a = (comment.editedText || "").trim();
        const b = (comment.textRaw || "").trim();
        return a && a !== b;
    }
    loadNewComment(item?: common.INote) {
        this.closeNewComment();
        this.closeComment();

        this.setCurrentlyAddingComment(item, true);
        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
    }
    closeNewComment(item?: common.INote | null) {
        item = item || this.getCurrentlyAddingCommentItem();
        if (item)
            item.commentNewText = "";

        this.currentCommentId = "";
        this.currentCommentText = "";
        this.currentCommentItemId = "";
        this.setCurrentlyAddingComment(item, false);
        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
    }
    saveNewComment(item: common.INote) {
        this.currentCommentText = item.commentNewText;
        this.currentCommentItemId = item.id;
        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
        this.$nextTick(() => {
            this.formManager?.applyUpdate("SaveNewComment", common.HotEditableActionTypes.update);
        });
    }
    saveComment(item?: common.INote, comment?: common.INoteCommentaire) {
        this.currentCommentItemId = item?.id;
        this.currentCommentId = comment?.id;
        this.currentCommentText = comment?.editedText || "";
        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
        this.$nextTick(() => {
            this.formManager?.applyUpdate("SaveComment", common.HotEditableActionTypes.update);
        });
    }
    closeComment(comment?: common.INoteCommentaire | null) {
        comment = comment || this.getCurrentlyEditingCommentItem();
        if (comment)
            comment.editedText = "";

        this.currentCommentId = "";
        this.currentCommentText = "";
        this.setCurrentlyEditionComment(comment, false);
        this.currentCommentItemId = "";
        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
    }
    checkItem(item?: common.INote) {
        // this.currentItemId = item.id;
        // this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
        // this.$nextTick(() => {
        //     this.formManager.applyUpdate(actionValue, common.HotEditableActionTypes.update);
        // });
    }
    deleteItem(item?: common.INote) {
        this.currentItemId = item?.id;
        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
        this.$nextTick(() => {
            this.formManager?.applyUpdate("DeleteItem", common.HotEditableActionTypes.update);
        });
    }
    deleteComment(comment?: common.INoteCommentaire) {
        this.currentCommentId = comment?.id;
        this.currentCommentItemId = comment?.idNote;
        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
        this.$nextTick(() => {
            this.formManager?.applyUpdate("DeleteComment", common.HotEditableActionTypes.update);
        });
    }
    resetCurrentItem() {
        const prevItem = this.getCurrentEditingItem();

        this.currentItemId = "";
        this.currentItemTitle = this._defaultCreationTitle;
        this.currentItem = null;

        this.formManager?.getFieldByName("Description")?.setFromTextualValue();

        const clear = this.formManager?.getButtonByName("Clear");
        const add = this.formManager?.getButtonByName("Add");
        const cancel = this.formManager?.getButtonByName("Cancel");
        const save = this.formManager?.getButtonByName("Save");

        clear?.show();
        add?.show();
        cancel?.hide();
        save?.hide();

        this.setCurrentlyEditionItem(prevItem, false);
        this.closeMessages();

        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
    }
    loadComment(comment?: common.INoteCommentaire) {
        const prevComment = this.getCurrentlyEditingCommentItem();
        if (prevComment)
            this.closeComment(prevComment);

        this.setCurrentlyEditionComment(comment, true);

        if (comment)
            comment.editedText = comment.textRaw.trim();

        this.currentCommentId = comment?.id;
        this.currentCommentItemId = comment?.idNote;

        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
    }
    /** Pour ajouter un nouvel item, laisse l'argument 'item' NULL.  */
    loadItem(item?: common.INote) {
        const prevItem = this.getCurrentEditingItem();

        this.currentItemId = item?.id;
        this.currentItemTitle = item?.title;
        this.currentItem = item;

        const description = this.formManager?.getFieldByName("Description");
        const clear = this.formManager?.getButtonByName("Clear");
        const add = this.formManager?.getButtonByName("Add");
        const cancel = this.formManager?.getButtonByName("Cancel");
        const save = this.formManager?.getButtonByName("Save");

        description?.setFromTextualValue(utilities.replaceBrTagByLineBreak(item?.description));

        clear?.hide();
        add?.hide();
        cancel?.show();
        save?.show();

        this.closeMessages();

        // toggle
        this.setCurrentlyEditionItem(prevItem, false);
        this.setCurrentlyEditionItem(item, true);

        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
    }
    getItemTypeTitle(item?: common.INote) {
        return "";
    }
    private setCurrentlyEditionItem(item?: common.INote | null, value?: boolean) {
        value = value !== false;

        this.currentlyEditingItem = value;

        if (item)
            item.currentlyEditingItem = value;
    }
    private setCurrentlyEditionComment(comment?: common.INoteCommentaire | null, value?: boolean) {
        value = value !== false;

        this.currentlyEditingComment = value;

        if (comment)
            comment.currentlyEditingComment = value;
    }
    private setCurrentlyAddingComment(item?: common.INote | null, value?: boolean) {
        value = value !== false;

        this.currentlyAddingComment = value;

        if (item)
            item.currentlyAddingComment = value;
    }
    private getCurrentEditingItem() {
        if (this.items) for (let i = 0; i < this.items.length; i++) {
            const x = this.items[i];
            if (x.currentlyEditingItem)
                return x;
        }

        return null;
    }
    private getCurrentlyAddingCommentItem() {
        if (this.items) for (let i = 0; i < this.items.length; i++) {
            const x = this.items[i];
            if (x.currentlyAddingComment)
                return x;
        }

        return null;
    }
    private getCurrentlyEditingCommentItem() {
        if (this.items) for (let i = 0; i < this.items.length; i++) {
            const x = this.items[i];
            if (x.comments)
                for (let j = 0; j < x.comments.length; j++) {
                    const y = x.comments[j];
                    if (y.currentlyEditingComment)
                        return y;
                }
        }

        return null;
    }
    private getItemById(id: string) {
        if (this.items) for (let i = 0; i < this.items.length; i++) {
            const x = this.items[i];
            if (x.id === id)
                return x;
        }

        return null;
    }
    private closeMessages() {
        this.formManager?.autoCloseMessages();
        context.components.getMessagesManager().closeBySource(this.formManager?.getFormName());
    }
    refreshBrotherEmbeddedComponents() {
        if (!this.shared?.isHotEmbeddedComponent()) throw "[EmbeddedComponent] Le formulaire actuel n'est pas un widget.";
        const name = this.shared.getCurrentEmbeddedComponentName();
        this.formManager?.refreshBrotherEmbeddedComponents(name);
        return this;
    }
    restoreBrotherEmbeddedComponents() {
        if (!this.shared?.isHotEmbeddedComponent()) throw "[EmbeddedComponent] Le formulaire actuel n'est pas un widget.";
        const name = this.shared.getCurrentEmbeddedComponentName();
        this.formManager?.restoreBrotherEmbeddedComponents(name);
        return this;
    }
    ensureBrotherEmbeddedComponentsIsDefaultUrl() {
        if (!this.shared?.isHotEmbeddedComponent()) throw "[EmbeddedComponent] Le formulaire actuel n'est pas un widget.";
        const name = this.shared.getCurrentEmbeddedComponentName();
        this.formManager?.ensureBrotherEmbeddedComponentsIsDefaultUrl(name);
        return this;
    }
    refreshForceUpdate() {
        this.forceUpdate = utilities.createGuid("N");
    }
}

export = NotesVue;
